import { useCallback, useState } from 'react';

export interface UseNumberOfChildrenInputProps {
  initialValue?: number;
}

export const useNumberOfChildrenInput = ({ initialValue = 1 }: UseNumberOfChildrenInputProps) => {
  const [childrenCount, setChildrenCount] = useState(initialValue);

  const handleIncreaseChildrenCount = useCallback(() => {
    setChildrenCount((prev) => prev + 1);
  }, [setChildrenCount]);

  const handleDecreaseChildrenCount = useCallback(() => {
    setChildrenCount((prev) => prev - 1);
  }, [setChildrenCount]);

  return {
    childrenCount,
    handleIncreaseChildrenCount,
    handleDecreaseChildrenCount,
  };
};
